<template lang="pug">
  div.container
    el-row.zIndex
      el-col.col1(
        :class="{'errorMapa' : errors.length}"
      )
        appMapa(
          @removerGeometria='removerGeometria'
          ref="mapa"
          :idMapa="idMapa",
          height="65vh",
          :mapLayersConfigs="layers"
          :featureLayerConfig="featureLayerConfig"
          :buttons="buttonsConfig",
          :configButtonsCamadas="configButtonsCamadas"
          :isAdicionandoPonto="isAdicionandoPonto"
          :configOrtoFotos="configOrtoFotos"
          @changeIsAdicionandoPonto="changeIsAdicionandoPonto"
          @adicionarPonto="adicionarPonto"
        )

        app-resumable(
          ref="resumable",
          :target="urlUpload",
          :fileType="validExtensions",
          idInput="upload",
          :fileTypeErrorCallback="fileTypeErrorCallback"
          @onSuccess="onSuccess",
          @onError="onError",
          @onProgress="onProgress",
          @fileAdded="onFileAdded"
        )

</template>

<script>
import AppMapa from '@/components/AppMapa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumable from '@/components/AppResumable'
import { mapActions } from 'vuex'
import layerStyles from '@/utils/layerStyles'

export default {

  components: {
    AppMapa,
    AppResumable
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    localizacoes: {
      required: false,
      type: Array
    },
    errors: {
      required: true,
      type: Array
    },
    idMapa: {
      type: String,
      required: true
    },
    tipoCadastro: {
      type: String,
      required: false,
      default: ''
    },
    addPonto: {
      type: Boolean,
      required: false,
      default: false
    },
    addOrtoFotos: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      validExtensions: ['zip', 'car'],
      isAdicionandoPonto: false,

      urlUpload: this.$rotas.PUBLICO.UPLOAD,

      featureLayerConfig: {
        url: process.env.URL_MAPSERVER_MUNICIPIOS,
        style: layerStyles.ESTADO,
        popup: (layer) => `${layer.feature.properties.NM_MUNICIP}`
      }
    }
  },

  computed: {
    layers () {
      if (!this.localizacoes) return []

      let layers = []
      for (let indice = 0; indice < this.localizacoes.length; indice++) {
        const container =
              '<button id="remover-geometria-button[' + indice + ']" class="button-popup" ' +
              'style="background-color: #fff; border: none; border-radius: 10px; ' +
              'color: #EF4836; text-align: center; padding: 10px; cursor: pointer; font-size:14px;" ' +
              'onmouseover="this.style.color=\'#FFF \'; this.style.backgroundColor=\'#EF4836\'";' +
              'onmouseout="this.style.color=\'#EF4836\'; this.style.backgroundColor=\'#FFF\'";>' +
              '<i class="el-icon-delete"></i>' +
              '&nbsp Remover Geometria</button>'; // eslint-disable-line

        const config = {
          minWidth: 100,
          closeButton: true
        }

        const layerConfig = {
          geoJson: this.localizacoes[indice].geometry ? this.localizacoes[indice].geometry : this.localizacoes[indice],
          popup: {container, config},
          idGeometria: indice
        }

        layers.push(layerConfig)
      }

      return layers
    },

    buttonsConfig () {
      let defaultButtons = [
        {
          id: 'centralizar',
          icon: 'fa-crosshairs',
          tooltip: 'Centralizar',
          onClick: this.centerMap
        },
        {
          id: 'upload',
          icon: 'fa-upload',
          tooltip: 'Enviar shapefile'
        }
      ]

      if (this.addPonto) {
        defaultButtons.push({
          id: 'addPonto',
          icon: 'el-icon-location',
          tooltip: 'Adicionar ponto',
          onClick: () => this.changeIsAdicionandoPonto()
        })
      }
      return defaultButtons
    },
    configButtonsCamadas () {
      if (process.env.ESTADO === 'ma') {
        return [{
          id: 'malha_maranhao_polygon',
          checked: false,
          class: 'malha-maranhao-polygon',
          layerName: 'Malha fundiária'
        },
        {
          id: 'sicarf_processos_ma',
          checked: false,
          class: 'sicarf-processos-ma',
          layerName: 'Processos Sicarf'
        }
        ]
      }
      return []
    },
    configOrtoFotos () {
      if (this.addOrtoFotos) {
        let ortoFotos = {
          maxZoom: 22,
          minZoom: 6
        }
        return ortoFotos
      }
      return null
    }
  },

  methods: {
    ...mapActions({
      resetLoader: 'loader/resetLoader',
      setLoaderWithText: 'loader/setLoaderWithText',
      calculateIntersect: 'cadastro/calculoIntersectGeoCentral'
    }),

    ...mapActions('retificacao', ['update']),

    centerMap () {
      this.$refs.mapa.recenterView()
    },

    adicionarPonto (ponto) {
      const geometry = {
        type: 'Point',
        coordinates: ponto
      }
      this.localizacoes.push(geometry)
    },

    clean () {
      this.resetLoader()
    },

    changeIsAdicionandoPonto () {
      if (!this.isAdicionandoPonto && this.localizacoes?.length) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Remova a geometria atual para prosseguir.')
        return
      }
      this.isAdicionandoPonto = !this.isAdicionandoPonto
    },

    fileTypeErrorCallback () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.validExtensions.join(', ')))
    },

    async onSuccess (value, fileKey) {
      // TODO realizar requisição para realizar sobreposição com os municípios
      this.clean()
      this.setLoaderWithText({
        status: true,
        text: 'Calculando interseções'
      })

      if (this.localizacoes.length > 0) {
        setTimeout(() => {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            'Remova a geometria atual para prosseguir.')
          this.resetLoader()
        }, 500)
        return
      }

      try {
        const data = {
          fileKey: fileKey,
          tipoCadastro: this.tipoCadastro
        }

        const response = await this.calculateIntersect(data)

        if (response.ok) {
          this.$emit('shapefileUploaded', {fileName: value.fileName, fileKey})
          this.sendDataToParent(response)
          this.atualizarGeorreferenciamento(response)
        } else {
          const erro = response?.erro ? JSON.parse(response.erro) : { }
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, erro?.results[0]?.value ? erro?.results[0]?.value : 'Geometria com erro')
        }
        this.resetLoader()
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERRO, error.message)

        setTimeout(() => {
          this.resetLoader()
        }, 500)
      }
    },

    onFileAdded (file) {
      this.$refs.resumable.uploadFile()
    },

    removerGeometria (idGeometria) {
      this.localizacoes.splice(idGeometria, 1)
      this.$emit('shapefileRemoved')
    },

    atualizarGeorreferenciamento (georreferenciamento) {
      this.localizacoes.push({ geometry: georreferenciamento.geom })
    },

    onError (message) {
      this.clean()
      this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, message)
    },

    onProgress (progress) {
      this.setLoaderWithText({
        status: true,
        text: `${progress}% concluído...`
      })
    },

    sendDataToParent (prop) {
      this.$emit('dataEmitted', prop.municipios)
    }
  },
  watch: {
    layers (val) {
      if (val) {
        const listLocalizacao = []
        val.forEach(item => {
          const obj = {
            geometry: item.geoJson,
            municipio: null,
            id: item.idGeometria
          }
          listLocalizacao.push(obj)
        })

        this.update({ field: 'georreferenciamento.localizacoes', value: listLocalizacao })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.removeArrecadacaoGeo {
  position: absolute;
  top: 105px;
  background-color: white;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  left: 10px;
  z-index: 400;
  display: flex;
  align-content: center;
  i {
    color: black;
    font-size: 12px;
  }

  &:focus {
    outline: none;
  }
}

.errorMapa {
  border: 2px solid $error;
  border-radius: 13px;
}

.zIndex {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/MapaRetificacao.vue